import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserAuthIamService } from '../user-auth-iam/user-auth-iam.service';
import { environment } from '../../env/environment';
import { timeout, catchError } from 'rxjs/operators';

export interface OptinParams {
    clientId?: string;
    deviceId: string;
    selfie: string;
    front: string;
    back: string;
}

export interface IOptin {
    clientId: string;
    personId: string;
    userId: string;
    status: string;
}

enum OptinStatus {
    PENDING = 'PENDING',
    APROVADO = 'APROVADO',
    FAILED = 'FAILED',
    REPROVADO = 'REPROVADO'
}

@Injectable({
    providedIn: 'root'
})
export class PersonValidateService {
    constructor(private http: HttpClient, private iamService: UserAuthIamService) {}

    public optin(params: OptinParams) {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this.iamService.accessTokenJWT}`,
            'Content-Type': 'application/json'
        });

        return this.http
            .post(environment.personValidationPath + '/person/validation', params, {
                headers
            })
            .pipe(
                catchError(error => {
                    throw error;
                })
            );
    }

    public optinStatus() {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${this.iamService.accessTokenJWT}`,
            'Content-Type': 'application/json'
        });

        return this.http.get(environment.personValidationPath + '/person/me', { headers }).pipe(timeout(30000));
    }

    public getPendingOptin(optinList: IOptin[]) {
        const filtered = optinList.filter(optin => optin.status === OptinStatus.PENDING);

        return filtered[0] || null;
    }
}
